// Toolkit components
import {
  PanelWithDrawers,
  TopPanel,
  Drawer,
} from "sj-ui-toolkit/src/atlas/components/PanelWithDrawers";

// Sub-components
import VideoPlayer from "./VideoPlayer";
import TextViewer from "./TextViewer";
import { VideoLessonDetails } from "../../VideoProvider";

// Main component
const VideoLessonContent = ({ lessonDetails }: { lessonDetails: VideoLessonDetails }) => {
  const { id: lessonId, videoId, assessment, events } = lessonDetails;

  return (
    <PanelWithDrawers resizable={true} className="h-full" testId="video-lesson-content">
      <TopPanel className="bg-elevation-2 rounded-l-sm p-3">
        <VideoPlayer
          videoId={videoId}
          lessonId={lessonId}
          watchedVideo={events.watchedVideo}
          assessmentId={assessment.id}
        />
      </TopPanel>
      <Drawer
        initialHeight="50%"
        title="Read the Lesson"
        className="bg-elevation-1 rounded-tl-sm pl-3"
      >
        <TextViewer lessonId={lessonId} readTranscript={events.readTranscript} />
      </Drawer>
    </PanelWithDrawers>
  );
};

export default VideoLessonContent;
